import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";
import { connect } from "react-redux";

export interface CutChargeMessagesProps {
    product?: ProductModel;
    extendedStyles?: CutChargeMessagesStyles;
}

const mapStateToProps = (state: ApplicationState) => {
    const currentPage = getCurrentPage(state);
    return {
        currentPage
    }
};

type Props = CutChargeMessagesProps & ReturnType<typeof mapStateToProps>;
export interface CutChargeMessagesStyles {
    cutChargeText?: TypographyPresentationProps;
}

const cutChargeMessagesStyles: CutChargeMessagesStyles = {
    cutChargeText: { size: "12px", }
}

const CutChargeMessages = ({ 
    product, 
    extendedStyles, 
    currentPage 
}: Props) => {
    if (!product || !product.detail) { return null; }
    
    const [styles] = React.useState(() => mergeToNew(cutChargeMessagesStyles, extendedStyles));

    const cutLengthUOMs = ["ROLL","REEL","SLEN"];    
    const foundUOMs = product.unitOfMeasures?.filter(uom => cutLengthUOMs.includes(uom.unitOfMeasure));
    if (!foundUOMs || foundUOMs.length === 0) { return null; }
    
    const useCutCharge = product.detail.hasMsds;
    
    if (!useCutCharge) { 
        if (currentPage.type === "ProductListPage") { return null; }
        return (
            <>
                {foundUOMs && foundUOMs.map((uom, index) => {
                    const noCutChargeMessage = `Product must be ordered by increments of the ${uom.unitOfMeasure} quantity.`;
                    return (
                        <Typography 
                            key={`uomMessage ${index}`}   
                            {...styles.cutChargeText} 
                        >
                            {noCutChargeMessage}
                        </Typography>
                    )
                })}
            </>
        ); 
    } 

    return (
        <>
            {foundUOMs && foundUOMs.map((uom, index) => {
                const useCutChargeMessage = currentPage.type !== "ProductListPage"
                    ? `Product will include a 10% cut charge if not ordered by the ${uom.unitOfMeasure}.`
                    : `Cut charges may apply`;
                return (
                    <Typography 
                        key={`uomMessage ${index}`}                 
                        {...styles.cutChargeText} 
                    >
                        {useCutChargeMessage}
                    </Typography>
                )
            })}
        </>
    );
};

export default connect(mapStateToProps)(CutChargeMessages);
